import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Heart, ArrowRight } from "lucide-react";
import { useSavedHomes } from "../lib/savedHomes";

// Floating "Saved homes" pill — appears only when count > 0.
// Sits top-center on mobile (under nav), bottom-center on desktop where it
// won't clash with the chatbot (bottom-left) or accessibility toolbar (bottom-right).
// Hidden on the saved-homes page itself.

export default function SavedHomesIndicator() {
  const { count } = useSavedHomes();
  const { pathname } = useLocation();

  if (count === 0) return null;
  if (pathname === "/saved-homes") return null;

  return (
    <Link
      to="/saved-homes"
      data-testid="saved-homes-indicator"
      aria-label={`Open saved homes — ${count} saved`}
      className="fixed z-40 left-1/2 -translate-x-1/2 bottom-4 md:bottom-8 inline-flex items-center gap-2.5 px-4 py-2.5 rounded-full alpha-gradient text-white shadow-2xl border border-white/20 backdrop-blur text-[13px] font-semibold hover:scale-[1.02] active:scale-95 transition-transform focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[color:var(--alpha-purple-300)]"
    >
      <Heart className="w-4 h-4 fill-current" aria-hidden />
      Saved homes
      <span
        className="inline-flex items-center justify-center min-w-[22px] h-[22px] px-1.5 rounded-full bg-white text-[color:var(--alpha-purple-700)] text-[11px] font-bold"
        data-testid="saved-homes-count"
      >
        {count}
      </span>
      <span className="hidden sm:inline-flex items-center gap-1 text-white/85">
        Compare <ArrowRight className="w-3.5 h-3.5" />
      </span>
    </Link>
  );
}
